import type { Permission } from '@tekansa/core/permissions';
import { Outlet } from 'react-router';
import { NoAccess } from '@/components/common/no-access';
import { useCan } from './permissions';
import { useSession } from './use-session';

/** Route guard (Step 15): the page, or "No access" when a deep link goes past the menus. */
export function RequirePermission({ permission }: { permission: Permission }) {
  return useCan(permission) ? <Outlet /> : <NoAccess />;
}

/** Tekansa staff pages by platform role. */
export function RequirePlatformRole({ roles }: { roles: ('super_admin' | 'support')[] }) {
  const { platformRole, actAs } = useSession();
  return platformRole && roles.includes(platformRole) && !actAs ? (
    <Outlet />
  ) : (
    <NoAccess what="Tekansa staff pages" />
  );
}
